import React, { useMemo, useState } from 'react';
import { FlatList, Platform, TouchableOpacity, View } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from '../NeedHelpDC';
import Typography from '../../typography/Typography';
import Icon from '../../icon/Icon';
import * as Animatable from 'react-native-animatable';
const HelpAndSupport = ({ height, contactUsDetails, goBackAction, faqData, userName, navigateToFaqScreen, triggerAction }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const handlePress = async (item, title) => {
        await triggerAction({
            ...navigateToFaqScreen,
            payload: {
                item,
                title,
                ...navigateToFaqScreen.payload
            }
        });
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Help and support', needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const calIcon = (iconName) => {
        const iconToken = IconTokens[iconName];
        return React.createElement(Icon, { name: iconToken, size: IconSizeTokens.XXXXXL });
    };
    const renderItem = ({ item, index }) => {
        return (React.createElement(TouchableOpacity, { onPress: () => {
                handlePress(item?.cards, item?.title);
            }, activeOpacity: 1, style: { marginTop: 12, padding: 8, borderWidth: 1, borderRadius: 8, backgroundColor: 'white', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderColor: '#E4E7EC' } },
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                calIcon(item?.icon),
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, label: item?.title }),
                    React.createElement(View, { style: { marginTop: 4 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, color: ColorTokens.Grey_Charcoal, label: item?.subtitle })))),
            React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night })));
    };
    const renderContent = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
            React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16, paddingBottom: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Primary_100, label: `Hi ${userName},` }),
                React.createElement(View, { style: { marginTop: 4 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night, label: `how can we help you today?` })),
                React.createElement(View, { style: { marginTop: 12 } },
                    React.createElement(FlatList, { data: faqData, renderItem: renderItem, keyExtractor: (item) => item.id })))));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.Grey_Milk, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null, showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }))) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default HelpAndSupport;
